import styled from 'styled-components';

import { Card, Button, Text } from '@gympass/yoga';

import * as EndUserStyles from '../EndUser/styles';

export const UserInfoContainer = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
`;

export const HeaderInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderLabel = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const HeaderButtonChat = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;

export const TabsContainer = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Divisor = styled(EndUserStyles.Divisor)``;

export const PreAssessmentCard = styled(Card)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const RecordContent = styled(Card.Content)`
  padding-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const Record = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.white};
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.medium}px;

  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;

  :nth-child(odd) {
    border-top: ${({ theme }) => theme.yoga.borders.small}px solid
      ${({ theme }) => theme.yoga.colors.tableBorder};
    border-bottom: ${({ theme }) => theme.yoga.borders.small}px solid
      ${({ theme }) => theme.yoga.colors.tableBorder};
    background-color: ${({ theme }) => theme.yoga.colors.elements.disabled};
  }

  strong {
    margin-bottom: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
    color: ${({ theme }) => theme.yoga.colors.text.primary};
  }

  p {
    color: ${({ theme }) => theme.yoga.colors.textDisabled};
  }
`;

export const RecordTitle = styled.div`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const PaginationControlWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
